/* eslint-disable */

/**
 * Copyright (c) Grab
 * Grab Design Tokens Project
 * Do not edit directly
 */


export const duxtonColorBaseNeutral50 = "#f5f5f5";
export const duxtonColorBaseNeutral75 = "#e8e8e8";
export const duxtonColorBaseNeutral100 = "#dbdbdb";
export const duxtonColorBaseNeutral200 = "#bfbfbf";
export const duxtonColorBaseNeutral300 = "#a3a3a3";
export const duxtonColorBaseNeutral400 = "#8c8c8c";
export const duxtonColorBaseNeutral500 = "#707070";
export const duxtonColorBaseNeutral600 = "#575757";
export const duxtonColorBaseNeutral700 = "#3d3d3d";
export const duxtonColorBaseNeutral800 = "#292929";
export const duxtonColorBaseNeutral900 = "#1a1a1a";
export const duxtonColorBaseNeutralWhite = "#ffffff";
export const duxtonColorBaseNeutralBlack = "#000000";
export const duxtonColorBaseBlue50 = "#ebfaff";
export const duxtonColorBaseBlue75 = "#ccf2ff";
export const duxtonColorBaseBlue100 = "#b3ebff";
export const duxtonColorBaseBlue200 = "#86d8f9";
export const duxtonColorBaseBlue300 = "#3ab5ee";
export const duxtonColorBaseBlue400 = "#1495e6";
export const duxtonColorBaseBlue500 = "#136fd8";
export const duxtonColorBaseBlue600 = "#0b54a8";
export const duxtonColorBaseBlue700 = "#0a3d71";
export const duxtonColorBaseBlue800 = "#0c2b45";
export const duxtonColorBaseBlue900 = "#0b1b23";
export const duxtonColorBaseOrange50 = "#fff4eb";
export const duxtonColorBaseOrange75 = "#ffe3cc";
export const duxtonColorBaseOrange100 = "#ffd3ad";
export const duxtonColorBaseOrange200 = "#ffb570";
export const duxtonColorBaseOrange300 = "#ff8404";
export const duxtonColorBaseOrange400 = "#f76708";
export const duxtonColorBaseOrange500 = "#ca3e07";
export const duxtonColorBaseOrange600 = "#9e3105";
export const duxtonColorBaseOrange700 = "#712304";
export const duxtonColorBaseOrange800 = "#4f1803";
export const duxtonColorBaseOrange900 = "#310f02";
export const duxtonColorBaseYellow50 = "#fff9c0";
export const duxtonColorBaseYellow75 = "#ffec8f";
export const duxtonColorBaseYellow100 = "#ffd933";
export const duxtonColorBaseYellow150 = "#ffc905";
export const duxtonColorBaseYellow200 = "#ffbc05";
export const duxtonColorBaseYellow250 = "#faab00";
export const duxtonColorBaseYellow300 = "#f09800";
export const duxtonColorBaseYellow350 = "#e58a00";
export const duxtonColorBaseYellow400 = "#cc7a00";
export const duxtonColorBaseYellow500 = "#a55f03";
export const duxtonColorBaseYellow600 = "#824703";
export const duxtonColorBaseRed50 = "#fdf2f2";
export const duxtonColorBaseRed75 = "#ffe2df";
export const duxtonColorBaseRed100 = "#ffd2cc";
export const duxtonColorBaseRed200 = "#ffa799";
export const duxtonColorBaseRed300 = "#ff7f6b";
export const duxtonColorBaseRed400 = "#f55538";
export const duxtonColorBaseRed500 = "#d42e1c";
export const duxtonColorBaseRed600 = "#ac1e11";
export const duxtonColorBaseRed700 = "#79150c";
export const duxtonColorBaseRed800 = "#530e08";
export const duxtonColorBaseRed900 = "#380a06";
export const duxtonColorBaseNeutralAlt50 = "#f3f6fb";
export const duxtonColorBaseNeutralAlt75 = "#e5e9f0";
export const duxtonColorBaseNeutralAlt100 = "#d7dce4";
export const duxtonColorBaseNeutralAlt200 = "#bac0c9";
export const duxtonColorBaseNeutralAlt300 = "#9fa4ad";
export const duxtonColorBaseNeutralAlt400 = "#868d95";
export const duxtonColorBaseNeutralAlt500 = "#697078";
export const duxtonColorBaseNeutralAlt600 = "#50565e";
export const duxtonColorBaseNeutralAlt700 = "#383e43";
export const duxtonColorBaseNeutralAlt800 = "#242a2e";
export const duxtonColorBaseNeutralAlt900 = "#161a1d";
export const duxtonColorBaseGreen50 = "#d9fcde";
export const duxtonColorBaseGreen75 = "#c6f4cc";
export const duxtonColorBaseGreen100 = "#b1eaba";
export const duxtonColorBaseGreen200 = "#78d389";
export const duxtonColorBaseGreen300 = "#3cb95a";
export const duxtonColorBaseGreen400 = "#00b14f";
export const duxtonColorBaseGreen500 = "#00804a";
export const duxtonColorBaseGreen600 = "#03633e";
export const duxtonColorBaseGreen700 = "#005339";
export const duxtonColorBaseGreen800 = "#002e27";
export const duxtonColorBaseGreen900 = "#001e1f";
export const duxtonColorBrandPrimarySoftest = "#d9fcde";
export const duxtonColorBrandPrimarySoft = "#b1eaba";
export const duxtonColorBrandPrimaryDefault = "#00b14f";
export const duxtonColorBrandPrimaryBold = "#00804a";
export const duxtonColorBrandPrimaryBoldest = "#005339";
export const duxtonColorBrandPrimaryTranslucent = "rgba(0, 177, 79, 0.15)";
export const duxtonColorBrandSecondarySoftest = "#eef9f9";
export const duxtonColorBrandSecondarySoft = "#b8e5df";
export const duxtonColorBrandSecondaryDefault = "#2d9f94";
export const duxtonColorBrandSecondaryBold = "#277c74";
export const duxtonColorBrandSecondaryBoldest = "#184440";
export const duxtonColorBackgroundDefault = "#ffffff";
export const duxtonColorBackgroundAlt = "#f5f5f5";
export const duxtonColorBackgroundTranslucent = "rgba(255, 255, 255, 0.24)";
export const duxtonColorBackgroundDefaultInverse = "#1a1a1a";
export const duxtonColorBackgroundAltInverse = "#3d3d3d";
export const duxtonColorBackgroundTranslucentInverse = "rgba(26, 26, 26, 0.6)";
export const duxtonColorBackgroundDisabled = "#f5f5f5";
export const duxtonColorBackgroundSurfaceLevel1 = "#ffffff";
export const duxtonColorBackgroundSurfaceLevel2 = "#ffffff";
export const duxtonColorBackgroundSurfaceLevel3 = "#ffffff";
export const duxtonColorContentDefault = "#1a1a1a";
export const duxtonColorContentSubtle = "#3d3d3d";
export const duxtonColorContentDim = "#707070";
export const duxtonColorContentPlaceholder = "#a3a3a3";
export const duxtonColorContentDisabled = "#bfbfbf";
export const duxtonColorContentDefaultInverse = "#ffffff";
export const duxtonColorContentTextLinkDefault = "#136fd8";
export const duxtonColorContentTextLinkBold = "#0b54a8";
export const duxtonColorContentTextLinkDefaultInverse = "#b3ebff";
export const duxtonColorContentOnBrandDefault = "#ffffff";
export const duxtonColorStatusAlertSoftest = "#fdf2f2";
export const duxtonColorStatusAlertSoft = "#ffd2cc";
export const duxtonColorStatusAlertDefault = "#d42e1c";
export const duxtonColorStatusAlertBold = "#ac1e11";
export const duxtonColorStatusAlertBoldest = "#79150c";
export const duxtonColorStatusAlertTranslucent = "rgba(212, 46, 28, 0.15)";
export const duxtonColorStatusInformativeSoftest = "#ebfaff";
export const duxtonColorStatusInformativeSoft = "#b3ebff";
export const duxtonColorStatusInformativeDefault = "#136fd8";
export const duxtonColorStatusInformativeBold = "#0b54a8";
export const duxtonColorStatusInformativeBoldest = "#0a3d71";
export const duxtonColorStatusPositiveSoftest = "#d9fcde";
export const duxtonColorStatusPositiveSoft = "#b1eaba";
export const duxtonColorStatusPositiveDefault = "#00b14f";
export const duxtonColorStatusPositiveBold = "#00804a";
export const duxtonColorStatusPositiveBoldest = "#005339";
export const duxtonColorStatusPositiveTranslucent = "rgba(0, 177, 79, 0.15)";
export const duxtonColorStatusNoticeSoftest = "#fff9c0";
export const duxtonColorStatusNoticeSoft = "#ffd933";
export const duxtonColorStatusNoticeDefault = "#f09800";
export const duxtonColorStatusNoticeBold = "#a55f03";
export const duxtonColorStatusNoticeBoldest = "#824703";
export const duxtonColorStatusNoticeAltSoftest = "#fff4eb";
export const duxtonColorStatusNoticeAltSoft = "#ffd3ad";
export const duxtonColorStatusNoticeAltDefault = "#f76708";
export const duxtonColorStatusNoticeAltBold = "#ca3e07";
export const duxtonColorStatusNoticeAltBoldest = "#9e3105";
export const duxtonColorStatusNeutralContrast = "#ffffff";
export const duxtonColorStatusNeutralSoftest = "#f5f5f5";
export const duxtonColorStatusNeutralSoft = "#dbdbdb";
export const duxtonColorStatusNeutralDefault = "#707070";
export const duxtonColorStatusNeutralBold = "#575757";
export const duxtonColorStatusNeutralBoldest = "#3d3d3d";
export const duxtonColorOutlineSoftest = "#e8e8e8";
export const duxtonColorOutlineSoft = "#dbdbdb";
export const duxtonColorOutlineDefault = "#bfbfbf";
export const duxtonColorOutlineBold = "#a3a3a3";
export const duxtonColorOutlineBoldest = "#8c8c8c";
export const duxtonColorOutlineDisabled = "#e8e8e8";
